export default [
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'eth',
    chainId: 1n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/279/large/ethereum.png'
  },
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'pol',
    chainId: 137n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/4713/large/matic-token-icon.png'
  },
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'ftm',
    chainId: 250n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/4001/large/Fantom.png'
  },
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'bnb',
    chainId: 56n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/825/large/bnb-icon2_2x.png'
  },
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'avax',
    chainId: 43114n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/12559/large/coin-round-red.png'
  },
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'aeth',
    chainId: 42161n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/279/large/ethereum.png'
  },
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'metis',
    chainId: 1088n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/15595/large/metis.PNG'
  },
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'eth',
    chainId: 8453n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/279/large/ethereum.png'
  },
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'glmr',
    chainId: 1284n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/22459/large/glmr.png'
  },
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'movr',
    chainId: 1285n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/17984/large/9285.png'
  },
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'xdai',
    chainId: 100n,
    disableGasTankDeposit: true,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/11062/large/Identity-Primary-DarkBG.png'
  },
  {
    chainId: 100n,
    address: '0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb',
    symbol: 'gno',
    decimals: 18,
    disableGasTankDeposit: true,
    icon: 'https://assets.coingecko.com/coins/images/662/standard/logo_square_simple_300px.png?1696501854'
  },
  {
    chainId: 100n,
    address: '0xe2e73a1c69ecf83f464efce6a5be353a37ca09b2',
    symbol: 'link',
    decimals: 18,
    disableGasTankDeposit: true,
    icon: 'https://assets.coingecko.com/coins/images/877/standard/chainlink-new-logo.png?1696502009'
  },
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'kcs',
    chainId: 321n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/1047/large/sa9z79.png'
  },
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'eth',
    chainId: 10n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/279/large/ethereum.png'
  },
  {
    address: '0x01bFF41798a0BcF287b996046Ca68b395DbC1071',
    symbol: 'usd₮0',
    chainId: 10n,
    decimals: 6,
    currencyIcon: 'https://assets.coingecko.com/coins/images/53705/standard/usdt0.jpg?1737086183'
  },
  {
    address: '0x4200000000000000000000000000000000000006',
    symbol: 'weth',
    chainId: 10n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/2518/small/weth.png'
  },
  {
    chainId: 10n,
    address: '0x76fb31fb4af56892a25e32cfc43de717950c9278',
    symbol: 'aave',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/12645/standard/aave-token-round.png?1720472354'
  },
  {
    chainId: 10n,
    address: '0x350a791bfc2c21f9ed5d10980dad2e2638ffa7f6',
    symbol: 'link',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/877/standard/chainlink-new-logo.png?1696502009'
  },
  {
    chainId: 10n,
    address: '0x68f180fcCe6836688e9084f035309E29Bf0A2095',
    symbol: 'wbtc',
    decimals: 8,
    icon: 'https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png'
  },
  {
    chainId: 10n,
    address: '0x9bcef72be871e61ed4fbbc7630889bee758eb81d',
    symbol: 'reth',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/20764/standard/reth.png?1696520159'
  },
  {
    chainId: 10n,
    address: '0x4200000000000000000000000000000000000042',
    symbol: 'op',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/25244/standard/Optimism.png?1696524385'
  },
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'okt',
    chainId: 66n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/13708/large/WeChat_Image_20220118095654.png'
  },
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'matic',
    chainId: 80001n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/4713/large/matic-token-icon.png'
  },
  {
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'eth',
    chainId: 11155111n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/279/large/ethereum.png'
  },
  {
    address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    symbol: 'weth',
    chainId: 1n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295'
  },
  {
    address: '0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29',
    symbol: 'jpyc',
    chainId: 1n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/70314/standard/JPYC_400x400.jpg'
  },
  {
    address: '0x1abaea1f7c830bd89acc67ec4af516284b1bc33c',
    symbol: 'eurc',
    chainId: 1n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/26045/standard/euro.png?1696525125'
  },
  {
    chainId: 1n,
    address: '0x514910771af9ca656af840dff83e8264ecf986ca',
    symbol: 'link',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/877/standard/chainlink-new-logo.png?1696502009'
  },
  {
    chainId: 1n,
    address: '0x40d16fc0246ad3160ccc09b8d0d3a2cd28ae6c2f',
    symbol: 'gho',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/30663/standard/gho-token-logo.png?1720517092'
  },
  {
    chainId: 1n,
    address: '0xae78736cd615f374d3085123a210448e74fc6393',
    symbol: 'reth',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/20764/standard/reth.png?1696520159'
  },
  {
    chainId: 1n,
    address: '0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9',
    symbol: 'aave',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/12645/standard/aave-token-round.png?1720472354'
  },
  {
    address: '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
    symbol: 'steth',
    chainId: 1n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/13442/standard/steth_logo.png'
  },
  {
    address: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    symbol: 'wsteth',
    chainId: 1n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/18834/standard/wstETH.png'
  },
  {
    address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    symbol: 'usdc',
    chainId: 1n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    symbol: 'usdt',
    chainId: 1n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png'
  },
  {
    address: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    symbol: 'dai',
    chainId: 1n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/9956/small/4943.png'
  },
  {
    address: '0x4Fabb145d64652a948d72533023f6E7A623C7C53',
    symbol: 'busd',
    chainId: 1n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/9576/small/BUSD.png'
  },
  {
    address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    symbol: 'wbtc',
    chainId: 1n,
    decimals: 8,
    icon: 'https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png'
  },
  {
    address: '0x88800092fF476844f74dC2FC427974BBee2794Ae',
    symbol: 'wallet',
    chainId: 1n,
    decimals: 18,
    icon: 'https://apis.zkxwallet.com/cena/iconProxy/ethereum/0x88800092fF476844f74dC2FC427974BBee2794Ae'
  },
  {
    address: '0x47Cd7E91C3CBaAF266369fe8518345fc4FC12935',
    disableGasTankDeposit: true,
    // disable if not in gas tank
    disableAsFeeToken: true,
    symbol: 'xwallet',
    chainId: 1n,
    decimals: 18,
    icon: 'https://apis.zkxwallet.com/cena/iconProxy/ethereum/0x47Cd7E91C3CBaAF266369fe8518345fc4FC12935'
  },
  {
    address: '0x028171bCA77440897B824Ca71D1c56caC55b68A3',
    baseToken: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    symbol: 'adai',
    chainId: 1n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/10843/small/aDAI.png',
    hiddenOnError: true
  },
  {
    address: '0xBcca60bB61934080951369a648Fb03DF4F96263C',
    baseToken: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    symbol: 'ausdc',
    chainId: 1n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/17226/small/aAMMUSDC_2x.png',
    hiddenOnError: true
  },
  {
    address: '0x3Ed3B47Dd13EC9a98b44e6204A523E766B225811',
    baseToken: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    symbol: 'ausdt',
    chainId: 1n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/17264/small/amUSDT_2x.png',
    hiddenOnError: true
  },
  {
    address: '0x9ff58f4fFB29fA2266Ab25e75e2A8b3503311656',
    baseToken: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    symbol: 'awbtc',
    chainId: 1n,
    decimals: 8,
    icon: 'https://assets.coingecko.com/coins/images/17265/small/amWBTC_2x.png',
    hiddenOnError: true
  },
  {
    address: '0x030bA81f1c18d280636F32af80b9AAd02Cf0854e',
    baseToken: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    symbol: 'aweth',
    chainId: 1n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/17266/small/amWETH_2x.png',
    hiddenOnError: true
  },
  {
    address: '0x6440f144b7e50D6a8439336510312d2F54beB01D',
    symbol: 'BOLD',
    chainId: 1n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/56069/standard/BOLD_logo.png?1748265087'
  },
  {
    address: '0xB58E61C3098d85632Df34EecfB899A1Ed80921cB',
    symbol: 'zchf',
    chainId: 1n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/37150/standard/Coin_Logo_Frankencoin_1024px.png?1728679791'
  },
  {
    address: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    symbol: 'wmatic',
    chainId: 137n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/14073/small/matic.png'
  },
  {
    address: '0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29',
    symbol: 'jpyc',
    chainId: 137n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/70314/standard/JPYC_400x400.jpg'
  },
  {
    address: '0x03b54a6e9a984069379fae1a4fc4dbae93b3bccd',
    symbol: 'wsteth',
    chainId: 137n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/18834/standard/wstETH.png'
  },
  {
    address: '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
    symbol: 'wbtc',
    chainId: 137n,
    decimals: 8,
    icon: 'https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png'
  },
  {
    address: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    symbol: 'weth',
    chainId: 137n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/2518/small/weth.png'
  },
  {
    address: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    symbol: 'dai',
    chainId: 137n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/9956/small/4943.png'
  },
  {
    address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    symbol: 'usdt',
    chainId: 137n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png'
  },
  {
    address: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    symbol: 'usdc.e',
    chainId: 137n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
    symbol: 'usdc',
    chainId: 137n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0x8dF3aad3a84da6b69A4DA8aeC3eA40d9091B2Ac4',
    baseToken: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    symbol: 'ammatic',
    chainId: 137n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/17267/small/amWMATIC_2x.png',
    hiddenOnError: true
  },
  {
    address: '0x27F8D03b3a2196956ED754baDc28D73be8830A6e',
    baseToken: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    symbol: 'amdai',
    chainId: 137n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/10843/small/aDAI.png',
    hiddenOnError: true
  },
  {
    address: '0x1a13F4Ca1d028320A707D99520AbFefca3998b7F',
    baseToken: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    symbol: 'amusdc',
    chainId: 137n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/17226/small/aAMMUSDC_2x.png',
    hiddenOnError: true
  },
  {
    address: '0x60D55F02A771d515e077c9C2403a1ef324885CeC',
    baseToken: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    symbol: 'amusdt',
    chainId: 137n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/17264/small/amUSDT_2x.png',
    hiddenOnError: true
  },
  {
    address: '0x5c2ed810328349100A66B82b78a1791B101C9D61',
    baseToken: '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
    symbol: 'amwbtc',
    chainId: 137n,
    decimals: 8,
    icon: 'https://assets.coingecko.com/coins/images/17265/small/amWBTC_2x.png',
    hiddenOnError: true
  },
  {
    address: '0x28424507fefb6f7f8E9D3860F56504E4e5f5f390',
    baseToken: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    symbol: 'amweth',
    chainId: 137n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/17266/small/amWETH_2x.png',
    hiddenOnError: true
  },
  {
    chainId: 137n,
    address: '0x0266f4f08d82372cf0fcbccc0ff74309089c74d1',
    symbol: 'reth',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/20764/standard/reth.png?1696520159'
  },
  {
    chainId: 137n,
    address: '0xd6df932a45c0f255f85145f286ea0b292b21c90b',
    symbol: 'aave',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/12645/standard/aave-token-round.png?1720472354'
  },
  {
    chainId: 137n,
    address: '0x53e0bca35ec356bd5dddfebbd1fc0fd03fabad39',
    symbol: 'link',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/877/standard/chainlink-new-logo.png?1696502009'
  },
  {
    chainId: 137n,
    address: '0xD4dD9e2F021BB459D5A5f6c24C12fE09c5D45553',
    symbol: 'zchf',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/37150/standard/Coin_Logo_Frankencoin_1024px.png?1728679791'
  },
  {
    address: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
    symbol: 'busd',
    chainId: 56n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/9576/small/BUSD.png'
  },
  {
    address: '0x55d398326f99059fF775485246999027B3197955',
    symbol: 'usdt',
    chainId: 56n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png'
  },
  {
    address: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    symbol: 'usdc',
    chainId: 56n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
    symbol: 'cake',
    chainId: 56n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/12632/standard/pancakeswap-cake-logo_%281%29.png?1696512440'
  },
  {
    chainId: 56n,
    address: '0xfb6115445bff7b52feb98650c87f44907e58f802',
    symbol: 'aave',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/12645/standard/aave-token-round.png?1720472354'
  },
  {
    chainId: 56n,
    address: '0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd',
    symbol: 'link',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/877/standard/chainlink-new-logo.png?1696502009'
  },
  {
    address: '0x049d68029688eAbF473097a2fC38ef61633A3C7A',
    symbol: 'usdt',
    chainId: 250n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png'
  },
  {
    address: '0x04068DA6C83AFCFA0e13ba15A6696662335D5B75',
    symbol: 'usdc',
    chainId: 250n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0x8D11eC38a3EB5E956B052f67Da8Bdc9bef8Abf3E',
    symbol: 'dai',
    chainId: 250n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/9956/small/4943.png'
  },
  {
    address: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
    symbol: 'wavax',
    chainId: 43114n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/15075/small/wrapped-avax.png'
  },
  {
    address: '0xE7C3D8C9a439feDe00D2600032D5dB0Be71C3c29',
    symbol: 'jpyc',
    chainId: 43114n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/70314/standard/JPYC_400x400.jpg'
  },
  {
    address: '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70',
    symbol: 'dai',
    chainId: 43114n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/9956/small/4943.png'
  },
  {
    address: '0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664',
    symbol: 'usdc.e',
    chainId: 43114n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
    symbol: 'usdc',
    chainId: 43114n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB',
    symbol: 'weth',
    chainId: 43114n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295'
  },
  {
    address: '0xc7198437980c041c805A1EDcbA50c1Ce5db95118',
    symbol: 'usdt.e',
    chainId: 43114n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png'
  },
  {
    address: '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7',
    symbol: 'usdt',
    chainId: 43114n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png'
  },
  {
    chainId: 43114n,
    address: '0xc891eb4cbdeff6e073e859e987815ed1505c2acd',
    symbol: 'eurc',
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/26045/standard/euro.png?1696525125'
  },
  {
    address: '0x50b7545627a5162F82A992c33b87aDc75187B218',
    symbol: 'wbtc',
    chainId: 43114n,
    decimals: 8,
    icon: 'https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png'
  },
  {
    address: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',
    symbol: 'usdc',
    chainId: 43114n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0xD4dD9e2F021BB459D5A5f6c24C12fE09c5D45553',
    symbol: 'zchf',
    chainId: 43114n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/37150/standard/Coin_Logo_Frankencoin_1024px.png?1728679791'
  },
  // commenting these out as they are disabled in the relayer as fee
  // {
  //   address: '0x82E64f49Ed5EC1bC6e43DAD4FC8Af9bb3A2312EE',
  //   baseToken: '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70',
  //   symbol: 'aavadai',
  //   chainId: 43114n,
  //   decimals: 18,
  //   icon: 'https://assets.coingecko.com/coins/images/10843/small/aDAI.png',
  //   hiddenOnError: true
  // },
  // {
  //   address: '0x625E7708f30cA75bfd92586e17077590C60eb4cD',
  //   baseToken: '0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664',
  //   symbol: 'aavausdc',
  //   chainId: 43114n,
  //   decimals: 6,
  //   icon: 'https://assets.coingecko.com/coins/images/17226/small/aAMMUSDC_2x.png',
  //   hiddenOnError: true
  // },
  // {
  //   address: '0x6ab707Aca953eDAeFBc4fD23bA73294241490620',
  //   baseToken: '0xc7198437980c041c805A1EDcbA50c1Ce5db95118',
  //   symbol: 'aavausdt',
  //   chainId: 43114n,
  //   decimals: 6,
  //   icon: 'https://assets.coingecko.com/coins/images/17264/small/amUSDT_2x.png',
  //   hiddenOnError: true
  // },
  // {
  //   address: '0x078f358208685046a11C85e8ad32895DED33A249',
  //   baseToken: '0x50b7545627a5162F82A992c33b87aDc75187B218',
  //   symbol: 'aavawbtc',
  //   chainId: 43114n,
  //   decimals: 8,
  //   icon: 'https://assets.coingecko.com/coins/images/17265/small/amWBTC_2x.png',
  //   hiddenOnError: true
  // },
  // {
  //   address: '0xe50fA9b3c56FfB159cB0FCA61F5c9D750e8128c8',
  //   baseToken: '0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB',
  //   symbol: 'aavaweth',
  //   chainId: 43114n,
  //   decimals: 18,
  //   icon: 'https://assets.coingecko.com/coins/images/17266/small/amWETH_2x.png',
  //   hiddenOnError: true
  // },
  {
    chainId: 43114n,
    address: '0x63a72806098bd3d9520cc43356dd78afe5d386d9',
    symbol: 'aave',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/12645/standard/aave-token-round.png?1720472354'
  },
  {
    chainId: 43114n,
    address: '0x5947bb275c521040051d82396192181b413227a3',
    symbol: 'link',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/877/standard/chainlink-new-logo.png?1696502009'
  },
  {
    address: '0xeFAeeE334F0Fd1712f9a8cc375f427D9Cdd40d73',
    symbol: 'usdt',
    chainId: 1284n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png'
  },
  {
    address: '0x765277EebeCA2e31912C9946eAe1021199B39C61',
    symbol: 'dai',
    chainId: 1284n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/9956/small/4943.png'
  },
  {
    address: '0xB44a9B6905aF7c801311e8F4E76932ee959c663C',
    symbol: 'usdt',
    chainId: 1285n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png'
  },
  {
    address: '0x80A16016cC4A2E6a2CACA8a4a498b1699fF0f844',
    symbol: 'dai',
    chainId: 1285n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/9956/small/4943.png'
  },
  {
    address: '0xbB06DCA3AE6887fAbF931640f67cab3e3a16F4dC',
    symbol: 'usdt',
    chainId: 1088n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png'
  },
  {
    address: '0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83',
    symbol: 'usdc',
    chainId: 100n,
    disableGasTankDeposit: true,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0x4ECaBa5870353805a9F068101A40E0f32ed605C6',
    symbol: 'usdt',
    chainId: 100n,
    disableGasTankDeposit: true,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png'
  },
  {
    address: '0xcB444e90D8198415266c6a2724b7900fb12FC56E',
    symbol: 'eure',
    chainId: 100n,
    disableGasTankDeposit: true,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/23354/standard/eur.png'
  },
  {
    address: '0xD4dD9e2F021BB459D5A5f6c24C12fE09c5D45553',
    symbol: 'zchf',
    chainId: 100n,
    disableGasTankDeposit: true,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/37150/standard/Coin_Logo_Frankencoin_1024px.png?1728679791'
  },
  {
    address: '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58',
    symbol: 'usdt',
    chainId: 10n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png'
  },
  {
    address: '0x7F5c764cBc14f9669B88837ca1490cCa17c31607',
    symbol: 'usdc.e',
    chainId: 10n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85',
    symbol: 'usdc',
    chainId: 10n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
    symbol: 'dai',
    chainId: 10n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/9956/small/4943.png'
  },
  {
    address: '0x1f32b1c2345538c0c6f582fcb022739c4a194ebb',
    symbol: 'wsteth',
    chainId: 10n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/18834/standard/wstETH.png'
  },
  {
    address: '0xD4dD9e2F021BB459D5A5f6c24C12fE09c5D45553',
    symbol: 'zchf',
    chainId: 10n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/37150/standard/Coin_Logo_Frankencoin_1024px.png?1728679791'
  },
  {
    address: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
    symbol: 'usdt',
    chainId: 42161n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png'
  },
  {
    address: '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
    symbol: 'usdc.e',
    chainId: 42161n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
    symbol: 'usdc',
    chainId: 42161n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
    symbol: 'dai',
    chainId: 42161n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/9956/small/4943.png'
  },
  {
    address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    symbol: 'weth',
    chainId: 42161n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/2518/small/weth.png'
  },
  {
    address: '0x5979d7b546e38e414f7e9822514be443a4800529',
    symbol: 'wsteth',
    chainId: 42161n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/18834/standard/wstETH.png'
  },
  {
    chainId: 42161n,
    address: '0xba5ddd1f9d7f570dc94a51479a000e3bce967196',
    symbol: 'aave',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/12645/standard/aave-token-round.png?1720472354'
  },
  {
    chainId: 42161n,
    address: '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f',
    symbol: 'wbtc',
    decimals: 8,
    icon: 'https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png'
  },
  {
    chainId: 42161n,
    address: '0xf97f4df75117a78c1a5a0dbb814af92458539fb4',
    symbol: 'link',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/877/standard/chainlink-new-logo.png?1696502009'
  },
  {
    chainId: 42161n,
    address: '0xec70dcb4a1efa46b8f2d97c310c9c4790ba5ffa8',
    symbol: 'reth',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/20764/standard/reth.png?1696520159'
  },
  {
    chainId: 42161n,
    address: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
    symbol: 'cbbtc',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/40143/standard/cbbtc.webp?1726136727'
  },
  {
    chainId: 42161n,
    address: '0x7dff72693f6a4149b17e7c6314655f6a9f7c8b33',
    symbol: 'gho',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/30663/standard/gho-token-logo.png?1720517092'
  },
  {
    chainId: 42161n,
    address: '0x912ce59144191c1204e64559fe8253a0e49e6548',
    symbol: 'arb',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/16547/standard/arb.jpg?1721358242'
  },
  {
    chainId: 42161n,
    address: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
    symbol: 'usd₮0',
    decimals: 6,
    currencyIcon: 'https://assets.coingecko.com/coins/images/53705/standard/usdt0.jpg?1737086183'
  },
  {
    chainId: 42161n,
    address: '0xD4dD9e2F021BB459D5A5f6c24C12fE09c5D45553',
    symbol: 'zchf',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/37150/standard/Coin_Logo_Frankencoin_1024px.png?1728679791'
  },
  {
    address: '0x382bB369d343125BfB2117af9c149795C6C65C50',
    symbol: 'usdc',
    chainId: 66n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0xc946DAf81b08146B1C7A8Da2A851Ddf2B3EAaf85',
    symbol: 'usdt',
    chainId: 66n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png'
  },
  {
    address: '0xEF71CA2EE68F45B9Ad6F72fbdb33d707b872315C',
    symbol: 'ethk',
    chainId: 66n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/18537/small/0xef71ca2ee68f45b9ad6f72fbdb33d707b872315c.png'
  },
  {
    address: '0xd9aAEc86B65D86f6A7B5B1b0c42FFA531710b6CA',
    symbol: 'usdbc',
    chainId: 8453n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0x0bbbead62f7647ae8323d2cb243a0db74b7c2b80',
    symbol: 'wallet',
    chainId: 8453n,
    decimals: 18,
    icon: 'https://apis.zkxwallet.com/cena/iconProxy/ethereum/0x88800092fF476844f74dC2FC427974BBee2794Ae'
  },
  {
    address: '0xc1cba3fcea344f92d9239c08c0568f6f2f0ee452',
    symbol: 'wsteth',
    chainId: 8453n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/18834/standard/wstETH.png'
  },
  {
    address: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
    symbol: 'usdc',
    chainId: 8453n,
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    address: '0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb',
    symbol: 'dai',
    chainId: 8453n,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/9956/small/4943.png'
  },
  {
    chainId: 8453n,
    address: '0x6bb7a212910682dcfdbd5bcbb3e28fb4e8da10ee',
    symbol: 'gho',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/30663/standard/gho-token-logo.png?1720517092'
  },
  {
    chainId: 8453n,
    address: '0x88fb150bdc53a65fe94dea0c9ba0a6daf8c6e196',
    symbol: 'link',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/877/standard/chainlink-new-logo.png?1696502009'
  },
  {
    chainId: 8453n,
    address: '0xb6fe221fe9eef5aba221c348ba20a1bf5e73624c',
    symbol: 'reth',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/20764/standard/reth.png?1696520159'
  },
  {
    chainId: 8453n,
    address: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
    symbol: 'aero',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/31745/standard/token.png?1696530564'
  },
  {
    chainId: 8453n,
    address: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
    symbol: 'cbbtc',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/40143/standard/cbbtc.webp?1726136727'
  },
  {
    chainId: 8453n,
    address: '0x60a3e35cc302bfa44cb288bc5a4f316fdb1adb42',
    symbol: 'eurc',
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/26045/standard/euro.png?1696525125'
  },
  {
    chainId: 8453n,
    address: '0xD4dD9e2F021BB459D5A5f6c24C12fE09c5D45553',
    symbol: 'zchf',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/37150/standard/Coin_Logo_Frankencoin_1024px.png?1728679791'
  },
  {
    chainId: 534352n,
    address: '0x06eFdBFf2a14a7c8E15944D1F4A48F9F95F663A4',
    symbol: 'usdc',
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    chainId: 534352n,
    address: '0xf55BEC9cafDbE8730f096Aa55dad6D22d44099Df',
    symbol: 'usdt',
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/32610/small/usdt_%281%29.png'
  },
  {
    chainId: 534352n,
    address: '0x5300000000000000000000000000000000000004',
    symbol: 'weth',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/32315/small/weth_%281%29.png?1697365181'
  },
  {
    chainId: 534352n,
    address: '0xf610A9dfB7C89644979b4A0f27063E9e7d7Cda32',
    symbol: 'wsteth',
    decimals: 18,
    icon: 'https://coin-images.coingecko.com/coins/images/18834/small/wstETH.png'
  },
  {
    // USDC
    address: '0x06eFdBFf2a14a7c8E15944D1F4A48F9F95F663A4',
    chainId: 130n,
    disableGasTankDeposit: true,
    symbol: 'usdc',
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    // usd₮0
    address: '0x9151434b16b9763660705744891fA906F660EcC5',
    chainId: 130n,
    disableGasTankDeposit: true,
    symbol: 'usd₮0',
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/53705/standard/usdt0.jpg?1737086183'
  },
  {
    // WETH
    address: '0x4200000000000000000000000000000000000006',
    chainId: 130n,
    disableGasTankDeposit: true,
    symbol: 'weth',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/32315/small/weth_%281%29.png?1697365181'
  },
  {
    // UNI
    address: '0x8f187aa05619a017077f5308904739877ce9ea21',
    chainId: 130n,
    disableGasTankDeposit: true,
    symbol: 'uni',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/12504/standard/uniswap-logo.png?1720676669'
  },
  {
    // USDC.e
    address: '0xF1815bd50389c46847f0Bda824eC8da914045D14',
    chainId: 57073n,
    disableGasTankDeposit: true,
    symbol: 'usdc.e',
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png'
  },
  {
    // usd₮0
    address: '0x0200C29006150606B650577BBE7B6248F58470c1',
    chainId: 57073n,
    disableGasTankDeposit: true,
    symbol: 'usd₮0',
    decimals: 6,
    icon: 'https://assets.coingecko.com/coins/images/53705/standard/usdt0.jpg?1737086183'
  },
  {
    // WETH
    address: '0x4200000000000000000000000000000000000006',
    chainId: 57073n,
    symbol: 'weth',
    disableGasTankDeposit: true,
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/32315/small/weth_%281%29.png?1697365181'
  },
  {
    // kBTC
    address: '0x73E0C0d45E048D25Fc26Fa3159b0aA04BfA4Db98',
    chainId: 57073n,
    disableGasTankDeposit: true,
    symbol: 'kbtc',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/50879/standard/kBTC.png?1730321084'
  },
  // ctUSD
  {
    address: '0x8D82c4E3c936C7B5724A382a9c5a4E6Eb7aB6d5D',
    chainId: 4114n,
    disableGasTankDeposit: true,
    symbol: 'ctUSD',
    decimals: 6,
    icon: 'https://coin-images.coingecko.com/coins/images/71615/standard/ctusd-logo.jpg'
  },
  // USDT.e
  {
    address: '0x9f3096Bac87e7F03DC09b0B416eB0DF837304dc4',
    chainId: 4114n,
    disableGasTankDeposit: true,
    symbol: 'USDT.e',
    decimals: 6,
    icon: 'https://coin-images.coingecko.com/coins/images/325/standard/Tether.png'
  },
  // USDC.e
  {
    address: '0xE045e6c36cF77FAA2CfB54466D71A3aEF7bbE839',
    chainId: 4114n,
    disableGasTankDeposit: true,
    symbol: 'USDC.e',
    decimals: 6,
    icon: 'https://coin-images.coingecko.com/coins/images/6319/standard/USDC.png'
  },
  // WBTC.e
  {
    chainId: 4114n,
    address: '0xDF240DC08B0FdaD1d93b74d5048871232f6BEA3d',
    disableGasTankDeposit: true,
    symbol: 'WBTC.e',
    decimals: 8,
    icon: 'https://coin-images.coingecko.com/coins/images/39529/standard/WBTCLOGO.png'
  },
  // ZKX / PulseChain (369). These four mirror `GET <relayer>/gas-tank/assets`,
  // which is the list the backend actually credits a deposit for. Without an
  // entry here `getFlags` leaves `canTopUpGasTank: false` (portfolio/helpers.ts)
  // and `TransferController.#setTokens` filters the token out, so the Top Up
  // Gas Tank screen renders an empty "You don't have any tokens" picker for an
  // account that is funded on PulseChain.
  //
  // PLS is native, so a top-up wraps it first (`getTransferRequestParams` ->
  // `isNativeTopUp`) and the relayer sees a WPLS transfer — which is why WPLS
  // must be listed too, and why `networks.ts` carries `wrappedAddr` for 369.
  {
    chainId: 369n,
    address: '0x0000000000000000000000000000000000000000',
    symbol: 'pls',
    decimals: 18,
    icon: 'https://apis.zkxwallet.com/cena/iconProxy/pulsechain/0xA1077a294dDE1B09bB078844df40758a5D0f9a27'
  },
  {
    chainId: 369n,
    address: '0xA1077a294dDE1B09bB078844df40758a5D0f9a27',
    symbol: 'WPLS',
    decimals: 18,
    icon: 'https://apis.zkxwallet.com/cena/iconProxy/pulsechain/0xA1077a294dDE1B09bB078844df40758a5D0f9a27'
  },
  {
    chainId: 369n,
    address: '0xc10A4Ed9b4042222d69ff0B374eddd47ed90fC1F',
    symbol: 'PCOCK',
    decimals: 18,
    icon: 'https://apis.zkxwallet.com/cena/iconProxy/pulsechain/0xc10A4Ed9b4042222d69ff0B374eddd47ed90fC1F'
  },
  {
    chainId: 369n,
    address: '0x15D38573d2feeb82e7ad5187aB8c1D52810B1f07',
    symbol: 'USDC',
    decimals: 6,
    icon: 'https://apis.zkxwallet.com/cena/iconProxy/pulsechain/0x15D38573d2feeb82e7ad5187aB8c1D52810B1f07'
  }
]
